import { Component, ViewModel, View } from "binder";
import  { ScrollViewerView } from "./scrollViewer-view"

export class ScrollViewerViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.horizontal=false;
        this.vertical=false;
    }
    GetDefaultView(): View <ViewModel> {
        return new ScrollViewerView();
    }
    public getTypeId(): string {
        return "VM-292B77FA-531E-4705-8899-8E0912E0DE5E"
    }

    public set content(v: ViewModel) { this._content = v; } public get content(): ViewModel { return this._content;} private _content: ViewModel;
    public set horizontal(v: boolean) { 
        if(typeof v=='boolean')
            this._horizontal = v;
        else
            this._horizontal = v=='true'; 
    } public get horizontal(): boolean { return this._horizontal;} private _horizontal: boolean;
    public set vertical(v: boolean) { 
        if(typeof v=='boolean')
            this._vertical = v;
        else
            this._vertical = v=='true'; 
    } public get vertical(): boolean { return this._vertical;} private _vertical: boolean;
    public set beginside(v: boolean) { this._beginside = v; } public get beginside(): boolean { return this._beginside;} private _beginside: boolean;
    
}
